import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './file-upload.css';

import LoaderComponent from "../../../libraries/loader/loader";
import { getFileUploadListFromServer } from '../../../services/demo/26as/medicalInsuranceFileUploadService';
import { getFileProcessFromServer } from '../../../services/demo/26as/medicalInsuranceReportService';
import { FetchUploadGl,Fetchexecutequery } from "../../../services/process/BRS1/brsService7";
import { baseUrl } from "../../../services/common/credentials";
import { port2 } from "../../../services/auth-service/authService";

const localhost_url = baseUrl + port2;

function MedicalInsuranceFileUpload() {
  const gridColumnDefs = [
    { field: 'source_type', headerName: 'Source Type', width: 130 },
    { field: 'file_type', headerName: 'File Type', width: 150 },
    { field: 'month', headerName: 'Input Date', width: 100 },
    { field: 'extraction_type', headerName: 'Extraction Type', width: 125 },
    { field: 'file_name', headerName: 'File Name', width: 200 },
    { field: 'file_size_bytes', headerName: 'File Size (KB)', width: 100 },
    { field: 'status', headerName: 'Status', width: 100 },
    { field: 'comments', headerName: 'Comments', width: 200 },
    { field: 'created_date', headerName: 'Upload Date Time', width: 200 }
  ];

  const [selectedOptions, setSelectedOptions] = useState();
  const [selectedChild, setSelectedChild] = useState(null);
  const [childOptions, setChildOptions] = useState([]);
  const [selectedOptions1, setSelectedOptions1] = useState(undefined);
  const [inputMonth, setInputMonth] = useState(undefined);
  const [monthOptions, setMonthOptions] = useState([
      { label: "April", value: "4" },
      { label: "May", value: "5" },
      { label: "June", value: "6" },
      { label: "July", value: "7" },
      { label: "August", value: "8" },
      { label: "September", value: "9" },
      { label: "October", value: "10" },
      { label: "November", value: "11" },
      { label: "December", value: "12" },
      { label: "January", value: "1" },
      { label: "February", value: "2" },
      { label: "March", value: "3" },
  ]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [finyr, setFinyr] = useState([]);
  const [filetypelist] = useState([
    { label: 'Groups', value: 'groups' },
    { label: 'Entities', value: 'entities' },
    { label: 'Division', value: 'division' },
    { label: 'Department', value: 'department' }
  ]);
  const [rowData, setRowData] = useState(undefined);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [compltedDateValue, setcompltedDateValue] = useState([]);
  const [paginationSize] = useState(15);

  const [selectedFile, setSelectedFile] = useState(null);
  const [relationChild, setRelationChild] = useState("gl");

  const userCredentials = JSON.parse(sessionStorage.getItem("userCredentials"));

  useEffect(() => {
    fetch_financial_year();
    fileUploadsList();
  }, []);


  const fetchtabledetailsInfo = async (query, setField, status = "yes") => {
    const payload = { query };
    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;

      if (data && data.length > 0) {
        if (status === "no") {
          setField(data);
        } else {
          const keys = Object.keys(data[0]);
          const labelKey = keys.find((k) => k.toLowerCase().includes("name"));
          const valueKey = keys.find((k) => k.toLowerCase().includes("_id"));

          const formatted = data.map((item) => ({
            label: item[labelKey],
            value: item[valueKey],
            description: item.description || "-",
            ...item
          }));
          setField(formatted);
        }
      } else {
        setField([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setField([]);
    }
  };

  const fetchChildOptions = async (selectedOption) => {
    setSelectedOptions(selectedOption);
    setSelectedChild(null);

    let parentQuery = "";
    switch (selectedOption.value.toLowerCase()) {
      case "groups":
        parentQuery = `SELECT groups_id, name FROM user_management_uat.groups WHERE is_active=1`;
        break;
      case "entities":
        parentQuery = `SELECT entity_id, name FROM user_management_uat.entities WHERE is_active=1`;
        break;
      case "division":
        parentQuery = `SELECT division_id, name FROM user_management_uat.divisions WHERE is_active=1`;
        break;
      case "department":
        parentQuery = `SELECT department_id, name FROM user_management_uat.departments WHERE is_active=1`;
        break;
      default:
        return;
    }

    try {
      setLoaderOpen(true);
      await fetchtabledetailsInfo(parentQuery, setChildOptions);
      setLoaderOpen(false);
    } catch (error) {
      console.error("Error fetching parent options:", error);
      setLoaderOpen(false);
    }
  };

  function fileUploadsList() {
    setLoaderOpen(true);
    const payload = {
      tenants_id: userCredentials["tenants_id"],
      entities_id: userCredentials["selectedentity"],
      m_processing_layer_id: userCredentials["m_processing_layer_id"],
      m_processing_sub_layer_id: userCredentials["m_processing_sub_layer_id"],
      processing_layer_id: userCredentials["processing_layer_id"],
      is_active: "yes",
    };

    const getFileUploadsList = getFileUploadListFromServer();
    axios.get(getFileUploadsList[1], { params: payload }, getFileUploadsList[0])
      .then(response => {
        const data = response.data;
        if (data && data.length) {
          data.forEach(row => {
            row["file_size_bytes"] = Math.round(row["file_size_bytes"] * 0.001) / 100;
          });
          setRowData(data);
          const completedMonths = data.filter(item => item.status === "COMPLETED").map(item => item.input_date);
          setcompltedDateValue(completedMonths);
        }
        setLoaderOpen(false);
      })
      .catch(error => {
        console.log("Error in File Upload List", error);
        setLoaderOpen(false);
      });
  }

  const generateFinancialYearOptions = (startYear, numYears) => {
    const optionsyr = [];
    for (let i = 0; i < numYears; i++) {
      const year1 = startYear + i;
      const year2 = year1 + 1;
      const financialYear = `${year1}-${year2}`;
      optionsyr.push({ key: financialYear, value: financialYear, label: financialYear });
    }
    return optionsyr;
  };

  function fetch_financial_year() {
    setLoaderOpen(true);
    const financialYearOptions = generateFinancialYearOptions(2020, 20);
    setFinyr(financialYearOptions);
    setLoaderOpen(false);
  }

  const handleFileUpload1 = () => {
    if (!selectedFile || !relationChild || !selectedChild?.value) {
      alert("Please select a file and child.");
      return;
    }

    let master_table = "";
    let refid = "";
    switch (selectedOptions.value.toLowerCase()) {
      case "groups":
        master_table = 'groups_tb_master';
        refid = 'group_id';
        break;
      case "entities":
        master_table = 'entity_tb_master';
        refid = 'entity_id';
        break;
      case "division":
        master_table = 'division_tb_master';
        refid = 'division_id';
        break;
      case "department":
        master_table = 'department_tb_master';
        refid = 'department_id';
        break;
      default:
        return;
    }


    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("schema_name", "gltest");
    formData.append("table", master_table);
    formData.append("tenant_id", 1);
    formData.append(refid, selectedChild.value);
    formData.append("fin_yr", selectedOptions1.value);



    const FileUploadCredentials = FetchUploadGl();
    axios.post(FileUploadCredentials[1], formData, {
      ...FileUploadCredentials[0],
      headers: {
        ...FileUploadCredentials[0].headers,
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        console.log("Child file upload response:", response);
        alert("File uploaded successfully!");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error uploading child file:", error);
      });
  };

  const searchForm = () => {
    setLoaderOpen(true);
    if (!selectedOptions1) {
      alert("Please select year before processing!");
      setLoaderOpen(false);
      return;
    }

    const payload = {
      tenants_id: userCredentials["tenants_id"],
      groups_id: userCredentials["groups_id"],
      entities_id: userCredentials["entities_id"],
      m_processing_layer_id: userCredentials["m_processing_layer_id"],
      m_processing_sub_layer_id: userCredentials["m_processing_sub_layer_id"],
      processing_layer_id: userCredentials["processing_layer_id"],
      is_active: "yes",
      input_date: inputMonth,
      period: selectedOptions1.label
    };

    const getFileProcess = getFileProcessFromServer();
    axios.post(getFileProcess[1], { params: payload }, getFileProcess[0])
      .then(response => {
        if (response.data["Status"] === "Success") {
          alert("File Processed Successfully!");
        }
        setLoaderOpen(false);
      })
      .catch(error => {
        console.log("Error in File Process", error);
        setLoaderOpen(false);
      });
  };

  const setdatevalue = (e) => {
    const date = e.target.value;
    const isDatePresent = compltedDateValue.includes(date);
    if (isDatePresent) {
      alert('Date is locked!');
      setInputMonth(null);
    } else {
      setInputMonth(date);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      {loaderOpen && <LoaderComponent open={loaderOpen} />}
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 10 }}>

          <div>
            <label>Financial Year</label>
            <Select
              options={finyr}
              value={selectedOptions1}
              onChange={(e) => setSelectedOptions1(e)}
              isSearchable={true}
            />
          </div>

        <div style={{ width: 250 }}>
          <label>Month</label>
          <Select options={monthOptions} value={selectedMonth} onChange={setSelectedMonth} isSearchable placeholder="Select Month" />
        </div>

          <div>
            <label>File Type</label>
            <Select
              options={filetypelist}
              value={selectedOptions}
              onChange={fetchChildOptions}
              isSearchable={true}
            />
          </div>

            <div>
              <label>Select Child</label>
              <Select
                options={childOptions}
                value={selectedChild}
                onChange={(e) => setSelectedChild(e)}
                isSearchable={true}
              />
            </div>



          <div>
            <label>Select File</label><br />
            <div style = {{display:"flex"}}>
             <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} />
             <button onClick={handleFileUpload1} className="btn" style={{ height: "35px", marginTop: "5px",marginLeft: "10px", backgroundColor: "#000055", color: "#ffffff" }}>
               Upload
             </button>
          </div>
          </div>
        </div>

        <div className="ag-theme-balham fileupload-layer">
          <AgGridReact
            columnDefs={gridColumnDefs}
            rowData={rowData}
            paginationPageSize={paginationSize}
            pagination={true}
            animateRows={true}
          />
        </div>
      </div>
    </div>
  );
}

export default MedicalInsuranceFileUpload;
